import { useEffect } from "react";
import { POLICY_CONFIG_ROUTE } from "Constants";
import { useAppDispatch, useAppSelector, useCurrentOrganization } from "Hooks";
import {
  addUnsavedChange,
  removeUnsavedChange,
  selectUnsavedChangesForPage,
} from "Modules/notification";
import { useGetWhoamiQuery } from "Services";
import {
  selectHasAnyUnsavedChanges,
  selectUnsavedChangesIds,
} from "../store/policyConfigSlice";

const useUnsavedChanges = () => {
  const { data: whoami } = useGetWhoamiQuery();
  const dispatch = useAppDispatch();
  const unsavedChangesIds = useAppSelector(selectUnsavedChangesIds);
  const currentOrganization = useCurrentOrganization();
  const hasAnyUnsavedChanges = useAppSelector(selectHasAnyUnsavedChanges);
  const unsavedChangeNotifications = useAppSelector((state) =>
    selectUnsavedChangesForPage(state, "policy"),
  );

  useEffect(() => {
    if (hasAnyUnsavedChanges) {
      unsavedChangesIds.forEach((id) => {
        if (!id || unsavedChangeNotifications[id]) return;

        if (id === currentOrganization?.id) {
          dispatch(
            addUnsavedChange({
              page: "policy",
              id: id,
              unsavedChange: {
                text: "You have unsaved organization policy configuration changes",
                navigateTo: `/organization/${currentOrganization.id}/${POLICY_CONFIG_ROUTE}`,
                remindMe: true,
              },
            }),
          );
        } else {
          const group = whoami?.org_groups.find(
            (group) => group.group_id === id,
          );
          dispatch(
            addUnsavedChange({
              page: "policy",
              id: id,
              unsavedChange: {
                text: `You have unsaved policy configuration changes for group ${group?.name}`,
                navigateTo: `/${POLICY_CONFIG_ROUTE}/group/${id}`,
                remindMe: true,
              },
            }),
          );
        }
      });
    } else {
      Object.keys(unsavedChangeNotifications).forEach((id) => {
        if (!unsavedChangesIds.includes(id)) {
          dispatch(removeUnsavedChange({ id: id, page: "policy" }));
        }
      });
    }
  }, [
    currentOrganization?.id,
    dispatch,
    hasAnyUnsavedChanges,
    unsavedChangesIds,
    unsavedChangeNotifications,
    whoami?.org_groups,
  ]);
};
export default useUnsavedChanges;
